// ContenuFiche/CreateTecnica.jsx
import React from 'react';
import {
  Box,
  FormControl,
  TextField,
  Typography,
  Button,
  CircularProgress,
  Grid
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import SpeechToTextButton from '../../components/SpeechToTextButton';

const decimalPattern = /^[0-9]{0,3}(\.[0-9]{0,2})?$/;

const CreateTecnica = ({
  fecha,
  setFecha,
  peso_kg,
  setPeso_kg,
  body_fat_porcentaje,
  setBody_fat_porcentaje,
  altura_con_zapatos,
  setAltura_con_zapatos,
  altura_sin_zapatos,
  setAltura_sin_zapatos,
  entrega_vertical,
  setEntrega_vertical,
  entrega_horizontal,
  setEntrega_horizontal,
  comentarios_observaciones_medidas,
  setComentarios_observaciones_medidas,
  escala_perfil_atletico,
  setEscala_perfil_atletico,
  informe_medico,
  setInforme_medico,
  ataque_asp_ind_puntos_fuertes,
  setAtaque_asp_ind_puntos_fuertes,
  ataque_asp_ind_objetivos_mejora,
  setAtaque_asp_ind_objetivos_mejora,
  ataque_asp_ind_observaciones_individuales,
  setAtaque_asp_ind_observaciones_individuales,
  ataque_asp_col_puntos_fuertes,
  setAtaque_asp_col_puntos_fuertes,
  ataque_asp_col_objetivos_mejora,
  setAtaque_asp_col_objetivos_mejora,
  ataque_asp_col_observaciones_colectivas,
  setAtaque_asp_col_observaciones_colectivas,
  defensa_asp_ind_puntos_fuertes,
  setDefensa_asp_ind_puntos_fuertes,
  defensa_asp_ind_objetivos_mejora,
  setDefensa_asp_ind_objetivos_mejora,
  defensa_asp_ind_observaciones_individuales,
  setDefensa_asp_ind_observaciones_individuales,
  defensa_asp_col_puntos_fuertes,
  setDefensa_asp_col_puntos_fuertes,
  defensa_asp_col_objetivos_mejora,
  setDefensa_asp_col_objetivos_mejora,
  defensa_asp_col_observaciones_colectivas,
  setDefensa_asp_col_observaciones_colectivas,
  info_audiovisual_observaciones,
  setInfo_audiovisual_observaciones,
  asp_fisicos_puntos_fuertes,
  setAsp_fisicos_puntos_fuertes,
  asp_fisicos_aspectos_potenciar,
  setAsp_fisicos_aspectos_potenciar,
  asp_fisicos_desarrollo_motriz,
  setAsp_fisicos_desarrollo_motriz,
  asp_fisicos_observaciones,
  setAsp_fisicos_observaciones,
  asp_psicologicos_observaciones,
  setAsp_psicologicos_observaciones,
  ambito_academico_observaciones,
  setAmbito_academico_observaciones,
  intel_observaciones,
  setIntel_observaciones,
  markDirty,
  isSubmitting,
  handleCreateCard,
  backendUrl
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: 3 }}>
      <FormControl fullWidth sx={{ mb: 3 }}>
        <TextField
          label={t('playerCardCreator.tecnicaForm.date')}
          variant="outlined"
          type="date"
          value={fecha}
          onChange={(e) => {
            setFecha(e.target.value);
            markDirty();
          }}
          InputLabelProps={{
            shrink: true
          }}
        />
      </FormControl>

      <Typography variant="h6" gutterBottom>
        {t('playerCardCreator.tecnicaForm.physicalMeasurements')}
      </Typography>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label={t('playerCardCreator.tecnicaForm.weight')}
            variant="outlined"
            value={peso_kg}
            onChange={(e) => {
              if (decimalPattern.test(e.target.value)) {
                setPeso_kg(e.target.value);
                markDirty();
              }
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label={t('playerCardCreator.tecnicaForm.bodyFat')}
            variant="outlined"
            value={body_fat_porcentaje}
            onChange={(e) => {
              if (decimalPattern.test(e.target.value)) {
                setBody_fat_porcentaje(e.target.value);
                markDirty();
              }
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label={t('playerCardCreator.tecnicaForm.heightWithShoes')}
            variant="outlined"
            value={altura_con_zapatos}
            onChange={(e) => {
              if (decimalPattern.test(e.target.value)) {
                setAltura_con_zapatos(e.target.value);
                markDirty();
              }
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label={t('playerCardCreator.tecnicaForm.heightWithoutShoes')}
            variant="outlined"
            value={altura_sin_zapatos}
            onChange={(e) => {
              if (decimalPattern.test(e.target.value)) {
                setAltura_sin_zapatos(e.target.value);
                markDirty();
              }
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label={t('playerCardCreator.tecnicaForm.verticalReach')}
            variant="outlined"
            value={entrega_vertical}
            onChange={(e) => {
              if (decimalPattern.test(e.target.value)) {
                setEntrega_vertical(e.target.value);
                markDirty();
              }
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label={t('playerCardCreator.tecnicaForm.horizontalReach')}
            variant="outlined"
            value={entrega_horizontal}
            onChange={(e) => {
              if (decimalPattern.test(e.target.value)) {
                setEntrega_horizontal(e.target.value);
                markDirty();
              }
            }}
          />
        </Grid>
      </Grid>

      {/* Comentarios y Observaciones */}
      <FormControl fullWidth sx={{ mt: 1 }}>
        <Typography variant="body1" gutterBottom>
          {t('playerCardCreator.tecnicaForm.commentsObservations')}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setComentarios_observaciones_medidas((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={comentarios_observaciones_medidas}
          onChange={(value) => {
            setComentarios_observaciones_medidas(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      {/* Escala Perfil Atlético */}
      <FormControl fullWidth sx={{ mt: 3 }}>
        <Typography variant="body1" gutterBottom>
          {t('playerCardCreator.tecnicaForm.athleticProfileScale')}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setEscala_perfil_atletico((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={escala_perfil_atletico}
          onChange={(value) => {
            setEscala_perfil_atletico(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      {/* Informe Medical */}
      <FormControl fullWidth sx={{ mt: 3, mb: 3 }}>
        <Typography variant="body1" gutterBottom>
          {t('playerCardCreator.tecnicaForm.medicalReport')}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setInforme_medico((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={informe_medico}
          onChange={(value) => {
            setInforme_medico(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      {/* Ataque - Aspectos Individuales */}
      <Typography variant="h6" gutterBottom>
        {t('playerCardCreator.tecnicaForm.attackIndividual')}
      </Typography>

      <FormControl fullWidth sx={{ mt: 1 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.strengths')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setAtaque_asp_ind_puntos_fuertes((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={ataque_asp_ind_puntos_fuertes}
          onChange={(value) => {
            setAtaque_asp_ind_puntos_fuertes(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mt: 3 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.improvementGoals')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setAtaque_asp_ind_objetivos_mejora((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={ataque_asp_ind_objetivos_mejora}
          onChange={(value) => {
            setAtaque_asp_ind_objetivos_mejora(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mt: 3, mb: 3 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.individualObservations')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setAtaque_asp_ind_observaciones_individuales((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={ataque_asp_ind_observaciones_individuales}
          onChange={(value) => {
            setAtaque_asp_ind_observaciones_individuales(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      {/* Ataque - Aspectos Colectivos */}
      <Typography variant="h6" gutterBottom>
        {t('playerCardCreator.tecnicaForm.attackCollective')}
      </Typography>

      <FormControl fullWidth sx={{ mt: 1 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.strengths')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setAtaque_asp_col_puntos_fuertes((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={ataque_asp_col_puntos_fuertes}
          onChange={(value) => {
            setAtaque_asp_col_puntos_fuertes(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mt: 3 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.improvementGoals')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setAtaque_asp_col_objetivos_mejora((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={ataque_asp_col_objetivos_mejora}
          onChange={(value) => {
            setAtaque_asp_col_objetivos_mejora(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mt: 3, mb: 3 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.collectiveObservations')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setAtaque_asp_col_observaciones_colectivas((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={ataque_asp_col_observaciones_colectivas}
          onChange={(value) => {
            setAtaque_asp_col_observaciones_colectivas(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      {/* Defensa - Aspectos Individuales */}
      <Typography variant="h6" gutterBottom>
        {t('playerCardCreator.tecnicaForm.defenseIndividual')}
      </Typography>

      <FormControl fullWidth sx={{ mt: 1 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.strengths')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setDefensa_asp_ind_puntos_fuertes((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={defensa_asp_ind_puntos_fuertes}
          onChange={(value) => {
            setDefensa_asp_ind_puntos_fuertes(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mt: 3 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.improvementGoals')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setDefensa_asp_ind_objetivos_mejora((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={defensa_asp_ind_objetivos_mejora}
          onChange={(value) => {
            setDefensa_asp_ind_objetivos_mejora(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mt: 3, mb: 3 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.individualObservations')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setDefensa_asp_ind_observaciones_individuales((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={defensa_asp_ind_observaciones_individuales}
          onChange={(value) => {
            setDefensa_asp_ind_observaciones_individuales(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      {/* Defensa - Aspectos Colectivos */}
      <Typography variant="h6" gutterBottom>
        {t('playerCardCreator.tecnicaForm.defenseCollective')}
      </Typography>

      <FormControl fullWidth sx={{ mt: 1 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.strengths')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setDefensa_asp_col_puntos_fuertes((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={defensa_asp_col_puntos_fuertes}
          onChange={(value) => {
            setDefensa_asp_col_puntos_fuertes(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mt: 3 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.improvementGoals')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setDefensa_asp_col_objetivos_mejora((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={defensa_asp_col_objetivos_mejora}
          onChange={(value) => {
            setDefensa_asp_col_objetivos_mejora(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mt: 3, mb: 3 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.collectiveObservations')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setDefensa_asp_col_observaciones_colectivas((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={defensa_asp_col_observaciones_colectivas}
          onChange={(value) => {
            setDefensa_asp_col_observaciones_colectivas(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      {/* Información Audiovisual */}
      <Typography variant="h6" gutterBottom>
        {t('playerCardCreator.tecnicaForm.audiovisualInfo')}
      </Typography>
      <FormControl fullWidth sx={{ mt: 1, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setInfo_audiovisual_observaciones((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={info_audiovisual_observaciones}
          onChange={(value) => {
            setInfo_audiovisual_observaciones(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      {/* Aspectos Físicos */}
      <Typography variant="h6" gutterBottom>
        {t('playerCardCreator.tecnicaForm.physicalAspects')}
      </Typography>
      <FormControl fullWidth sx={{ mt: 1 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.strengths')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setAsp_fisicos_puntos_fuertes((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={asp_fisicos_puntos_fuertes}
          onChange={(value) => {
            setAsp_fisicos_puntos_fuertes(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mt: 3 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.aspectsToEnhance')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setAsp_fisicos_aspectos_potenciar((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={asp_fisicos_aspectos_potenciar}
          onChange={(value) => {
            setAsp_fisicos_aspectos_potenciar(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mt: 3 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.motorDevelopment')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setAsp_fisicos_desarrollo_motriz((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={asp_fisicos_desarrollo_motriz}
          onChange={(value) => {
            setAsp_fisicos_desarrollo_motriz(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mt: 3, mb: 3 }}>
        <Typography>{t('playerCardCreator.tecnicaForm.observations')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setAsp_fisicos_observaciones((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={asp_fisicos_observaciones}
          onChange={(value) => {
            setAsp_fisicos_observaciones(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      {/* Aspectos Psicológicos */}
      <Typography variant="h6" gutterBottom>
        {t('playerCardCreator.tecnicaForm.psychologicalAspects')}
      </Typography>
      <FormControl fullWidth sx={{ mt: 1, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setAsp_psicologicos_observaciones((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={asp_psicologicos_observaciones}
          onChange={(value) => {
            setAsp_psicologicos_observaciones(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      {/* Ámbito Académico */}
      <Typography variant="h6" gutterBottom>
        {t('playerCardCreator.tecnicaForm.academicScope')}
      </Typography>
      <FormControl fullWidth sx={{ mt: 1, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setAmbito_academico_observaciones((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={ambito_academico_observaciones}
          onChange={(value) => {
            setAmbito_academico_observaciones(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      {/* INTEL */}
      <Typography variant="h6" gutterBottom>
        {t('playerCardCreator.tecnicaForm.intelSection')}
      </Typography>
      <FormControl fullWidth sx={{ mt: 1, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setIntel_observaciones((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={intel_observaciones}
          onChange={(value) => {
            setIntel_observaciones(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.tecnicaForm.observations')}
        />
      </FormControl>

      <Button
        variant="contained"
        color="primary"
        onClick={handleCreateCard}
        sx={{ mt: 3 }}
        fullWidth
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <>
            <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
            {t('playerCardCreator.tecnicaForm.saving')}
          </>
        ) : (
          t('playerCardCreator.tecnicaForm.saveTechniques')
        )}
      </Button>
    </Box>
  );
};

export default CreateTecnica;
